import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { PostHogProvider } from 'posthog-js/react'
import posthog from 'posthog-js'

// Initialize PostHog with error tracking enabled
posthog.init('phc_AKw63M8ARyTLjIzHYlCHEuPiMIYdBlEpYaVrXSHDhcB', {
  api_host: 'https://us.i.posthog.com',
  person_profiles: 'identified_only',
  // Enable error tracking and performance monitoring
  capture_pageview: true,
  capture_pageleave: true,
  autocapture: true,
  capture_performance: true,
  // Enable session recording for better debugging
  session_recording: {
    enabled: true,
    recordCrossOriginIframes: true
  },
  // Capture unhandled promise rejections
  capture_console_logs: ['error', 'warn'],
  // Enable error boundary
  loaded: (posthog) => {
    if (process.env.NODE_ENV === 'development') {
      posthog.debug();
    }
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
      <App />
    </PostHogProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
